export default "__VITE_ASSET__SM1IRJAo__"